import { render, staticRenderFns } from "./ParticipantStatusEditor.vue?vue&type=template&id=353d1c77&"
import script from "./ParticipantStatusEditor.vue?vue&type=script&lang=ts&"
export * from "./ParticipantStatusEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VExpansionPanelContent,VSelect})
